import React from 'react';
import PropTypes from 'prop-types';
import styles from './confirmModal.module.css';

export default function ConfirmModal({
  isOpen,
  confirmCB,
  cancelCB,
  title = 'Delete Provider Profile',
  message = 'Are you sure that you would like to delete your profile? This cannot be undone.',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
}) {
  return (
    <div className={isOpen ? styles.openModal : styles.closedModal}>
      <h3>{title}</h3>
      <p>{message}</p>
      <div className={styles.buttonContainer}>
        <button onClick={cancelCB} className={styles.cancelButton}>
          {cancelText}
        </button>
        <button onClick={confirmCB} className={styles.confirmButton}>
          {confirmText}
        </button>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  confirmCB: PropTypes.func,
  cancelCB: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
};
